import $ from 'jquery'

$(() => {
  $('#toggle-navbar-search').on('click', function() {
    $(this).toggleClass('active');
    $('#navbar-search').toggleClass('navbar-search--visible');
  });
});